var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor",domProps:{"innerHTML":_vm._s(_vm.returnText(_vm.termsText))}})
}
var staticRenderFns = []

export { render, staticRenderFns }